export default "__VITE_ASSET__01bcbca2__"